import { keepPreviousData } from '@tanstack/react-query';
import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { memberQueryKeys } from 'TeamModule/query/membersQueryKeys';
import {
  searchMembersByFieldsApi,
  SearchMembersByFieldsPayload,
  SearchMembersByFieldsResponse,
} from 'TeamModule/api/searchMembersByFieldsApi';

export const useSearchMembersByFieldsQuery = (
  params: (SearchMembersByFieldsPayload | Record<string, any>) & { enabled?: boolean },
) => {
  const { enabled = true, ...rest } = params as any;

  const { data: queryData, ...query } = useAppQuery<{
    data: SearchMembersByFieldsResponse;
  }>({
    queryKey: memberQueryKeys.list({ identifier: `useSearchMembersByFieldsQuery`, ...rest }),
    queryFn: ({ token, buildConfig }) =>
      searchMembersByFieldsApi({ params: rest, token, config: buildConfig() }),
    staleTime: 30000, // 30 seconds - prevents aggressive refetching
    gcTime: 5 * 60 * 1000, // 5 minutes - keep cached data longer
    refetchOnWindowFocus: false,
    refetchOnMount: false, // Don't refetch on component mount if data exists
    placeholderData: keepPreviousData, // Keep previous data while fetching to prevent UI flicker
    enabled,
  });

  return { membersSearch: queryData?.data, ...query };
};

export default useSearchMembersByFieldsQuery;
